import { render, staticRenderFns } from "./ColorRefinementList.vue?vue&type=template&id=4731fc8b&scoped=true"
import script from "./ColorRefinementList.vue?vue&type=script&lang=js"
export * from "./ColorRefinementList.vue?vue&type=script&lang=js"
import style0 from "./ColorRefinementList.vue?vue&type=style&index=0&id=4731fc8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731fc8b",
  null
  
)

export default component.exports